<template>
  <div class="custom-card">
    <v-toolbar-title class="mb-4 py-2" style="border-bottom: 1px solid #d4dbe0">
      <v-row dense>
        <v-col cols="12" md="6" lg="6">
          <span>COMISIONES: {{ nombreRecurso }}</span>
        </v-col>
      </v-row>
    </v-toolbar-title>

    <v-row dense>
      <v-col cols="12" md="9" xl="10">
        <v-btn class="mx-1" title="Recargar" small @click="listar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>

        <v-btn
          class="mx-1"
          color="primary"
          title="Registrar"
          small
          @click="$refs.modalFormularioTipoDocumentoPersona.abrir(acciones.REGISTRAR)">
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-btn
          class="mx-1"
          title="Editar"
          small
          :disabled="itemSeleccionado == null"
          @click="$refs.modalFormularioTipoDocumentoPersona.abrir(acciones.EDITAR, itemSeleccionado)">
          <v-icon>mdi-pencil</v-icon>
          Editar
        </v-btn>

        <v-btn class="mx-1" title="Eliminar" small :disabled="itemSeleccionado == null" @click="confirmarEliminacion">
          <v-icon>mdi-close</v-icon>
          Eliminar
        </v-btn>
      </v-col>

      <v-col cols="12" md="3" xl="2">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="busqueda"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="buscar"></v-text-field>
      </v-col>

      <v-col cols="12">
        <ListadoTiposDocumentosPersona
          ref="listadoRef"
          :rowData="items"
          :cargando="cargando"
          @seleccionarItem="seleccionarItem" />
      </v-col>
    </v-row>

    <ModalFormularioTipoDocumentoPersona
      ref="modalFormularioTipoDocumentoPersona"
      nombreItem="TIPO DOCUMENTO PERSONA"
      @actualizarListado="listar" />

    <ConfirmacionAccion ref="confirmacionRef" v-bind="confirmacion" @aceptar="eliminar" />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import layoutMixin from '../mixins/layout.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import TiposDocumentosPersonaService from '../services/tipos-documentos-persona.service';
import ListadoTiposDocumentosPersona from './components/ListadoTiposDocumentosPersona';
import ModalFormularioTipoDocumentoPersona from './components/ModalFormularioTipoDocumentoPersona.vue';
import { ACCIONES } from '../utils/constantes';
import ConfirmacionAccion from '../components/ConfirmacionAccion.vue';

export default {
  name: 'TiposDocumentosPersonaLayout',
  mixins: [layoutMixin, apiConsumerMixin],
  components: {
    ListadoTiposDocumentosPersona,
    ModalFormularioTipoDocumentoPersona,
    ConfirmacionAccion,
  },
  data() {
    return {
      nombreRecurso: 'TIPOS DOCUMENTOS PERSONA',
      acciones: ACCIONES,
      confirmacion: {
        titulo: 'Acción a confirmar',
        mensaje: /*html*/ `¿Esta seguro que desea realizar esta acción?`,
        realizandoAccion: false,
      },
    };
  },
  mounted() {
    this.listar();
  },
  methods: {
    async listar() {
      await this.findAllMixin(
        TiposDocumentosPersonaService.findAll,
        null,
        this.nombreRecurso,
        () => {
          this.items = [];
          this.itemSeleccionado = null;
          this.cargando = true;
        },
        () => {
          this.cargando = false;
        },
        (datos) => {
          this.items = datos;
        },
        () => {
          this.items = [];
          this.itemSeleccionado = null;
        },
      );
    },
    confirmarEliminacion() {
      this.confirmacion.titulo = 'Eliminar Tipo Documento Persona';
      this.confirmacion.mensaje = /*html*/ `¿Está seguro de eliminar el tipo documento persona <strong>${this.itemSeleccionado?.nombre}</strong>?`;
      this.confirmacion.realizandoAccion = false;
      this.$refs.confirmacionRef.abrir();
    },
    async eliminar() {
      await this.removeMixin(
        TiposDocumentosPersonaService.remove,
        { id: this.itemSeleccionado.id },
        null,
        this.nombreRecurso,
        () => {
          this.confirmacion.realizandoAccion = true;
          this.$refs.confirmacionRef.cerrar();
        },
        () => {
          this.confirmacion.realizandoAccion = false;
        },
        () => {
          this.listar();
          this.itemSeleccionado = null;
        },
      );
    },
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 8px;
  margin: 0px 8px 0px 8px;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>